import I18N from '@leverege/i18n';
import ResponsiveListView from "./ResponsiveListView.js";
import ItemModelInitializer from "../../attributes/ItemsModelInitializer.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.list.ListDataViewer');
export default {
  id: 'molten.dataViewers.list.ListDataViewer',
  type: 'molten.List',
  name: tf('listViewer'),
  icon: tfIcon('listIcon', 'fa fa-list fa-fw'),
  location: 'none',
  matches: {
    type: 'GroupDataViewer'
  },
  component: ResponsiveListView,
  settingsUpdaters: DataViewerModelUpdaterCreator.create('ItemViewModelUpdater'),
  createSettings: props => {
    const {
      objectType
    } = props;
    return ItemModelInitializer.create(objectType);
  },
  reset: async props => {
    // await UserSettings.reset( props.settingsPath )
  },
  getDefaultCardContentOptions: {
    height: '400px'
  }
};